import React from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
// import {ReactSVG} from 'react-svg';

import {theme} from '../../../themes/default-theme';
// import figureLarge from '../../../assets/icons/figure.svg';
// import figureSmall from '../../../assets/icons/figure-small.svg';
// import Text from '../../../components/typography';

const Container = styled.div`
  display: flex;
  justify-content: ${props => props.hasTitle ? 'end' : 'space-between'};
  align-items: center;
  margin: 20px 0;
  text-align: left;
  border-top: 1px solid ${theme.palette.middleGrey};
  ${props => props.color && `color: ${props.color}`};

  ${theme.breakpoints.down('sm')} {
    ${props => !props.hasTitle && 'display: block'};
  }
`

const List = styled.div`
  display: flex;
  align-items: flex-end;
`

const Item = styled.div`
  ${props => props.size === 'large' ? `
    margin-right: 7px;
    svg {
      width: 11px;
      height: 30px;

      ${theme.breakpoints.up('lg')} {
        width: 15px;
        height: 41px;
      }
    }
  ` : `
    margin-right: 3px;
    svg {
      width: 7px;
      height: 17px;
      ${theme.breakpoints.up('lg')} {
        width: 10px;
        height: 23px;
      }
    }
  `}
`

const Key = styled.div`
  display: block;
  width: 100%;
  ${props => props.inline === 1 && `
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${theme.palette.middleGrey};
  `}

`

const KeyItem = styled.div`
  position: relative;
  padding-left: 20px;
  font-size: 12px;
  padding-top: 10px;
  padding-bottom: 10px;

  span {
    display: inline-block;
    width: 50%;
  }
  ${props => props.inline === 0 ? `
    border-bottom: 1px solid ${theme.palette.middleGrey};
  ` : `
    span {
      width: auto;
      margin-right: 5px;
    }
  `}

  ${theme.breakpoints.down('sm')} {
    margin-left: 0;
    margin-right: 10px;
  }

  ${theme.breakpoints.up('lg')} {
    ${props => props.inline === 0 ? `
    font-size: 14px;
    ` : `
    font-size: 16px;
    `
    }

    ${props => props.size === 'large' && `
      padding-top: 20px;
      padding-bottom: 20px;
    `
    }
  }

  &:before {
    content: ' ';
    width: 8px;
    height: 8px;
    display: block;
    position: absolute;
    margin-right: 5px;
    left: 0;
    background-color: ${props => props.dot || 'transparent'};
    border-radius: 10px;

    ${props => props.inline === 0 ? `
      top: 15px;
    ` : `
      top: 16px;
    `}

    ${theme.breakpoints.up('lg')} {
      width: 10px;
      height: 10px;
      margin-right: 10px;

      ${props => props.size === 'large' && `
        top: 26px;
      `
      }
    }
  }
}

`

const Title = styled.div`
  width: 50%;
`

const SleepKey = ({
  standard = null,
  optional = null,
  title = null,
  inline = false,
  color = theme.palette.gunmentalGrey,
  size = 'medium'
}) => {

  return (
  	standard || optional ? <Container size={size} color={color} className="key-container">
      <Key inline={inline ? 1 : 0} size={size}>
        {standard &&
        <KeyItem dot="#D6E6D1" inline={inline ? 1 : 0} size={size} className="key-item">
          <span>Sleeps standard:</span>
          <span>{standard}</span>
        </KeyItem>
        }
        {optional &&
          <KeyItem dot="#A8CAD0" inline={inline ? 1 : 0} size={size} className="key-item">
            <span>Sleeps optional:</span>
            <span>{optional}</span>
          </KeyItem>
        }
      </Key>
    </Container>
    : null
  )
}

SleepKey.propTypes = {
  standard: propTypes.string,
  optional: propTypes.string,
  title: propTypes.string,
  inline: propTypes.bool,
  color: propTypes.string,
  size: propTypes.string
}

export default SleepKey